import { runTokenIntents } from '../token';
import { Priority } from './constants';
import { runElementTransforms } from './element';
import { addIntentsToRevision } from './ViewRevision';
import { runLazyStyleIntents } from '../style/StyleIntent';
export function runDomIntents(revision, options, cssPolicy) {
    addIntentsToRevision(revision, runTokenIntents(revision, cssPolicy), Priority.Normal);
    runElementTransforms(revision);
    runLazyStyleIntents(revision, options, cssPolicy);
}

//# sourceMappingURL=dom.js.map